import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Badge from "components/Badge";
import InfoTooltipIcon from "components/CustomTooltip/InfoTooltipIcon";

import {getScoreTheme} from "../../../../../utils/ScoreColorCalculator";

DescriptionScore.propTypes = {
    score: PropTypes.number
};

function DescriptionScore({score = null}) {
    // TODO we don't have this score yet
    return null;

    if (score == null) {
        return null;
    }

    const scoreTheme = getScoreTheme(score)

    return (
        <Badge
            rounded={true}
            indicator={'circle'}
            size={'large'}
            labelSize={14}
            color={scoreTheme.theme}
            labelColor={scoreTheme.color}
            isBold={false}
            border={true}
        >
            <div style={{
                display: 'flex',
                alignItems: 'center'
            }}>
                <span>
                    <FormattedMessage id='product.show.product.form.field.description.score' /> {score}%
                </span>
                <span style={{display: 'flex', marginLeft: '5px'}}>
                    <InfoTooltipIcon color={scoreTheme.color} titleId='product.show.product.form.field.description.score.tooltip'/>
                </span>
            </div>
        </Badge>
    );
}

export default DescriptionScore;
